import React from "react";

const Button = ({
  icon,
  label,
  color = "primary",
  textColor = "white",
  font = "gSemi",
  className = "",
  ...props
}) => {
  return (
    <button
      className={`bg-${color} text-${textColor} text-md font-${font} p-2 px-6 uppercase rounded-lg ${className}`}
      {...props}
      data-testid={`button-${label}`}
    >
      {icon && <span className={"pr-2"}>{icon}</span>}
      {label}
    </button>
  );
};

export default Button;
